import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const ParagraphGridIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3H7C7.55228 3 8 3.44771 8 4L8 7C8 7.55228 7.55229 8 7 8H4.00001C3.44772 8 3.00001 7.55228 3.00001 7L3 4C3 3.44772 3.44772 3 4 3ZM4 12H7C7.55228 12 8 12.4477 8 13L8 16C8 16.5523 7.55229 17 7 17H4.00001C3.44772 17 3.00001 16.5523 3.00001 16L3 13C3 12.4477 3.44772 12 4 12ZM9.75 4C9.75 3.58579 10.0858 3.25 10.5 3.25H17C17.4142 3.25 17.75 3.58579 17.75 4C17.75 4.41421 17.4142 4.75 17 4.75H10.5C10.0858 4.75 9.75 4.41421 9.75 4ZM10.5 6.25C10.0858 6.25 9.75 6.58579 9.75 7C9.75 7.41421 10.0858 7.75 10.5 7.75H17C17.4142 7.75 17.75 7.41421 17.75 7C17.75 6.58579 17.4142 6.25 17 6.25H10.5ZM9.75 13C9.75 12.5858 10.0858 12.25 10.5 12.25H17C17.4142 12.25 17.75 12.5858 17.75 13C17.75 13.4142 17.4142 13.75 17 13.75H10.5C10.0858 13.75 9.75 13.4142 9.75 13ZM10.5 15.25C10.0858 15.25 9.75 15.5858 9.75 16C9.75 16.4142 10.0858 16.75 10.5 16.75H17C17.4142 16.75 17.75 16.4142 17.75 16C17.75 15.5858 17.4142 15.25 17 15.25H10.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
